import { Pipe, PipeTransform } from '@angular/core';
import { ProductDetails } from '@models';

@Pipe({ name: 'productSearchPipe', pure: false, standalone: true })
export class ProductSearchPipe implements PipeTransform {
  transform(products: (number | any)[], args: string): Array<any> {
    const searchText = new RegExp(args, 'ig');

    if (products) {
      return products.filter((product: ProductDetails) => {
        if (product.name) {
          return product.name.search(searchText) !== -1;
        }
        return [];
      });
    }

    return [];
  }
}
